import { Coordinate } from '../../types/Site';

const EARTH_RADIUS_METERS = 6371000;
const MIN_RADIUS_METERS = 100;
const MAX_RADIUS_METERS = 80000;

export interface NativeRegion {
  latitude: number;
  longitude: number;
  /**
   * Full edge-to-edge span in degrees, matching react-native-maps' native `Region` convention --
   * NOT a center-to-edge half-span. MapViewWeb currently computes half-span deltas
   * (`MapViewWeb.js`), so its region must be doubled before reaching this type; feeding it
   * through unconverted will under-compute radiusMeters by 2x once the web map is wired up here.
   */
  latitudeDelta: number;
  longitudeDelta: number;
}

export function regionToSearchParams(nativeRegion: NativeRegion): {
  center: Coordinate;
  radiusMeters: number;
} {
  const latRad = (nativeRegion.latitude * Math.PI) / 180;
  const metersPerDegreeLat = (Math.PI / 180) * EARTH_RADIUS_METERS;
  const metersPerDegreeLon = metersPerDegreeLat * Math.cos(latRad);

  const heightMeters = nativeRegion.latitudeDelta * metersPerDegreeLat;
  const widthMeters = nativeRegion.longitudeDelta * metersPerDegreeLon;
  const diagonalMeters = Math.sqrt(heightMeters ** 2 + widthMeters ** 2) / 2;

  const radiusMeters = Math.min(MAX_RADIUS_METERS, Math.max(MIN_RADIUS_METERS, Math.round(diagonalMeters)));

  return {
    center: { latitude: nativeRegion.latitude, longitude: nativeRegion.longitude },
    radiusMeters,
  };
}
